module.exports = __webpack_public_path__ + "img/german-bundesliga-8__dark.c4f4456e.png";